import h from "../services/h";
import departmentService from "../services/departmentService";
import constants from "../constants";
import utils from "../services/utils";
// import utils from "../services/utils";

export default {
    data() {
        return {
            userDeptRoleHandlers: [],
            departmentHandlers: [],
            roots: [],
            handlerOrderMap: {} //map id (userDeptRoleId || deptId) vs cáu hình bước tiếp theo;
        };
    },

    methods: {
        getOrderByHandlerId(id) {
            return this.handlerOrderMap ? this.handlerOrderMap[id] : null;
        },

        getOrderOfHandlerNode(node) {
            let order = null;
            switch (node.nodeType) {
                case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
                    order = node.department.order;
                    break;
                case constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE:
                    order = node.userDeptRole.positionOrder;
                    break;
            }
            if (!order && order !== 0) return null;
            return order + 1;
        },

        buildNodes() {
            if (this.userDeptRoleHandlers) {
                this.userDeptRoleHandlers.sort((item1, item2) =>
                    utils.compareUserDeptRoleView(item1, item2)
                );
            }

            if (this.departmentHandlers) {
                this.departmentHandlers.sort((item1, item2) =>
                    utils.compareDepartment(item1, item2)
                );
            }


            this.roots = [];
            let departmentsIds = h.collect(
                this.departmentHandlers,
                department => department.id
            );
            let departmentsParentIds = h.collect(
                this.departmentHandlers,
                department => department.parentId
            );
            let userDeptRolesDeptIds = h.collect(
                this.userDeptRoleHandlers,
                userDeptRole => userDeptRole.deptId
            );
            let departmentIdsSet = [];
            h.each(
                departmentsIds,
                id => departmentIdsSet.indexOf(id) === -1 && departmentIdsSet.push(id)
            );
            h.each(
                departmentsParentIds,
                id => departmentIdsSet.indexOf(id) === -1 && departmentIdsSet.push(id)
            );
            h.each(
                userDeptRolesDeptIds,
                id => departmentIdsSet.indexOf(id) === -1 && departmentIdsSet.push(id)
            );
            return (departmentIdsSet && departmentIdsSet.length
                ? this.loadDepartments(departmentIdsSet)
                : Promise.resolve([])
            ).then(allDepartments => {
                h.each(allDepartments, department => {
                    let isRoot =
                        h.indexOf(
                            allDepartments,
                            parentDepartment => parentDepartment.id === department.parentId
                        ) === -1;
                    isRoot && this.roots.push(this.initNodeForDept({}, department));
                });

                let nodes = [];
                nodes.push(...this.roots);
                let index = 0;
                while (index < nodes.length) {
                    let node = nodes[index];
                    if (node.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT) {
                        let department = node.department;

                        let subUserDeptRoles =
                            this.userDeptRoleHandlers.filter(
                                userDeptRole => userDeptRole.deptId === department.id
                            ) || [];

                        let userDeptRoleChildNodes = h.collect(
                            subUserDeptRoles,
                            subUserDeptRole =>
                                this.initNodeForUserDeptRole({}, subUserDeptRole)
                        );

                        let subDepartments =
                            allDepartments.filter(
                                subDepartment => subDepartment.parentId === department.id
                            ) || [];

                        let departmentChildNodes = h.collect(
                            subDepartments,
                            subDepartment => this.initNodeForDept({}, subDepartment)
                        );

                        let childNodes = [];
                        userDeptRoleChildNodes &&
                            childNodes.push(...userDeptRoleChildNodes);
                        departmentChildNodes && childNodes.push(...departmentChildNodes);

                        nodes.push(...childNodes);
                        this.setParentChildren(node, childNodes);
                    }
                    index++;
                }
                h.each(this.roots, root => this.hieuChinhTreeByOrder(root));
                h.each(this.roots, root => this.hieuChinhTree(root));
            });
        },

        setParentChildren(node, childNodes) {
            this.$set(node, "children", childNodes);
            if(node && node.department && node.department.id) {
                this.$set(node, "id", node && node.department && node.department.id);
            }
            h.each(childNodes, childNode => this.$set(childNode, "parent", node));
        },

        hieuChinhTreeByOrder(data) {
            if (data.children) {
                data.children.sort((childNode1, childNode2) => {
                    return this.compareNode(childNode1, childNode2);
                });
                h.each(data.children, childNode =>
                    this.hieuChinhTreeByOrder(childNode)
                );
            }
        },

        compareNode(node1, node2) {
            let node1Type = node1.nodeType;
            let node2Type = node2.nodeType;
            if (node1Type === node2Type) {
                let compareResult;
                switch (node1Type) {
                    case constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE:
                        compareResult =
                            (this.getOrderOfHandlerNode(node1) || 100000) -
                            (this.getOrderOfHandlerNode(node2) || 100000);
                        if (compareResult !== 0) return compareResult;
                        else
                            return utils.compareUserDeptRoleView(
                                node1.userDeptRole,
                                node2.userDeptRole
                            );
                    case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
                        compareResult =
                            (this.getOrderOfHandlerNode(node1) || 100000) -
                            (this.getOrderOfHandlerNode(node2) || 100000);
                        if (compareResult !== 0) return compareResult;
                        else
                            return utils.compareDepartment(
                                node1.department,
                                node2.department
                            );
                    default:
                        return 0;
                }
            } else {
                return 0;
            }
        },

        /**
         * bo sung cac node PBCN, DVTT, PBCNAndDVTT ...
         */
        hieuChinhTree(data) {
            switch (data.nodeType) {
                case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
                    let department = data.department;
                    if (department.id === constants.DEPARTMENT.DEPT_CODE.TCT) {
                        let childNodes = [];
                        // build node BanGD
                        // let banTGDNodes =
                        //   data.children.filter(
                        //     child =>
                        //       (child.nodeType ===
                        //         constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE) &&
                        //       child.userDeptRole.roleCode === constants.ROLE.CODE.LANH_DAO
                        //   );
                        // if (banTGDNodes && banTGDNodes.length)
                        //   childNodes.push(this.initNodeForBanTGDNode({}, banTGDNodes));

                        // build node HDTV
                        let hdtvNode = h.find(
                            data.children,
                            childNode =>
                                childNode.nodeType ===
                                constants.DEPARTMENT_TREE.NODE_TYPE.DEPT &&
                                childNode.department.deptCode === constants.HDTV_DEPT_CODE
                        );
                        if (hdtvNode) childNodes.push(hdtvNode);

                        // build node PBCNAndDVTT
                        let pbcnNodes =
                            data.children.filter(childNode =>
                            (childNode.nodeType ===
                                constants.DEPARTMENT_TREE.NODE_TYPE.DEPT &&
                                childNode.department.deptType ===
                                constants.DEPARTMENT.DEPT_TYPE.PBCN));

                        let dvttNodes =
                            data.children.filter(
                                childNode =>
                                    childNode.nodeType ===
                                    constants.DEPARTMENT_TREE.NODE_TYPE.DEPT &&
                                    childNode.department.deptType ===
                                    constants.DEPARTMENT.DEPT_TYPE.DVTT
                            );

                        if (
                            (pbcnNodes && pbcnNodes.length) ||
                            (dvttNodes && dvttNodes.length)
                        )
                            childNodes.push(
                                this.initNodeForPBCNAndDVTT({}, pbcnNodes, dvttNodes)
                            );

                        // co the co cac node khac > build nhung node con sot lai;
                        let otherNodes =
                            data.children.filter(
                                childNode =>
                                    // (!banTGDNodes || banTGDNodes.indexOf(childNode) === -1) &&
                                    hdtvNode !== childNode &&
                                    (!pbcnNodes || pbcnNodes.indexOf(childNode) === -1) &&
                                    (!dvttNodes || dvttNodes.indexOf(childNode) === -1)
                            );

                        if (otherNodes && otherNodes.length) childNodes.unshift(...otherNodes);
                        this.setParentChildren(data, childNodes);
                    } else {
                        let childNodes = [];

                        let caNhanNodes =
                            data.children.filter(
                                child =>
                                    child.nodeType ===
                                    constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
                            );
                        if (caNhanNodes) {
                            caNhanNodes = caNhanNodes.sort((node1, node2) =>
                                utils.compareUserDeptRoleView(
                                    node1.userDeptRole,
                                    node2.userDeptRole
                                )
                            );
                        }

                        let donviNodes =
                            data.children.filter(
                                child =>
                                    child.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT
                            );
                        if (donviNodes) {
                            donviNodes = donviNodes.sort((node1, node2) =>
                                utils.compareDepartment(node1.department, node2.department)
                            );
                        }

                        let otherNodes =
                            data.children.filter(
                                child =>
                                    (!caNhanNodes || caNhanNodes.indexOf(child) === -1) &&
                                    (!donviNodes || donviNodes.indexOf(child) === -1)
                            );

                        if (caNhanNodes) childNodes.push(...caNhanNodes);
                        if (donviNodes) childNodes.push(...donviNodes);
                        if (otherNodes) childNodes.push(...otherNodes);

                        this.setParentChildren(data, childNodes);
                    }
                    break;
                default:
                    break;
            }

            h.each(data.children, childNode => this.hieuChinhTree(childNode));
        },

        initNodeForPBCNAndDVTT(node, pbcnNodes, dvttNodes) {
            let childNodes = [];
            if (pbcnNodes && pbcnNodes.length)
                childNodes.push(this.initNodeForPBCN({}, pbcnNodes));
            if (dvttNodes && dvttNodes.length)
                childNodes.push(this.initNodeForDVTT({}, dvttNodes));
            this.$set(
                node,
                "nodeType",
                constants.DEPARTMENT_TREE.NODE_TYPE.PBCNAndDVTT
            );
            this.$set(
                node,
                "id",
                constants.DEPARTMENT_TREE.NODE_TYPE.PBCNAndDVTT
            );
            this.setParentChildren(node, childNodes);
            return node;
        },

        initNodeForPBCN(node, pbcnNodes) {
            // pbcnNodes = pbcnNodes.sort((node1, node2) =>
            //   utils.compareDepartment(node1.department, node2.department)
            // );
            this.$set(node, "nodeType", constants.DEPARTMENT_TREE.NODE_TYPE.PBCN);
            this.$set(node, "id", constants.DEPARTMENT_TREE.NODE_TYPE.PBCN);
            this.setParentChildren(node, pbcnNodes);
            return node;
        },

        initNodeForDVTT(node, dvttNodes) {
            // dvttNodes = dvttNodes.sort((node1, node2) =>
            //   utils.compareDepartment(node1.department, node2.department)
            // );
            this.$set(node, "nodeType", constants.DEPARTMENT_TREE.NODE_TYPE.DVTT);
            this.$set(node, "id", constants.DEPARTMENT_TREE.NODE_TYPE.DVTT);
            this.setParentChildren(node, dvttNodes);
            return node;
        },

        initNodeForBanTGDNode(node, banTGDNodes) {
            // banTGDNodes = banTGDNodes.sort((node1, node2) =>
            //   utils.compareUserDeptRoleView(node1.userDeptRole, node2.userDeptRole)
            // );
            this.$set(node, "nodeType", constants.DEPARTMENT_TREE.NODE_TYPE.BTGD);
            this.setParentChildren(node, banTGDNodes);
            return node;
        },

        initNodeForDept(node, department) {
            this.$set(node, "department", department);
            this.$set(node, "nodeType", constants.DEPARTMENT_TREE.NODE_TYPE.DEPT);
            this.$set(
                node,
                "isHandlerNode",
                h.exists(this.departmentHandlers, item => item.id === department.id)
            );
            return node;
        },

        initNodeForUserDeptRole(node, userDeptRole) {
            this.$set(node, "userDeptRole", userDeptRole);
            this.$set(node, "isHandlerNode", true);
            this.$set(
                node,
                "nodeType",
                constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
            );
            return node;
        },

        loadDepartments(departmentIdsSet) {
            return this.filterChildDepartment().then(result => {
                return departmentService
                    .findAllByIdIn(departmentIdsSet, constants.DEPARTMENT.STATUS.ACTIVE)
                    .then((response) => {
                        if (response.data.map(x => x.id).indexOf(result.currentDepartment.parentId) !== -1) {
                            return response.data.filter(x => x.id !== "ROOT");
                        } else {
                            return response.data.filter(x => x.id !== "ROOT" && result.newDepartments.indexOf(x.id) !== -1)
                        }
                    });
            })
        },

        // Lọc phòng ban con của phòng ban hiện tại
        filterChildDepartment() {
            return departmentService.findAll().then(res => {
                let newDepartments = [];
                let departments = [];
                departments = res.data.filter(x => x.status === "active");
                let currentDepartment = departments.find(x => x.id === this.$store.getters.userDeptRole.deptId);
                newDepartments = [currentDepartment];
                newDepartments.forEach((element) => {
                    newDepartments = [
                        ...newDepartments,
                        ...departments.filter((item) => item.parentId === element.id),
                    ];
                });
                return {
                    currentDepartment,
                    newDepartments: newDepartments && newDepartments.length && newDepartments.map(item => item.id)
                };
            })
        }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/handlersTreeMixinV2.js